export default {
  delete: '삭제',
  edit: '수정',
  cancel: '취소',
  clear: '지우기',
  new: '새로 만들기',
  update: '업데이트',
  undo: '실행 취소',
  option: '옵션',
  details: '세부정보',
  deleting: '삭제 중',
  createdAt: '생성일',
  firstSeen: '최초 확인',
  lastActive: '마지막 활동',
  'idle.title': '세션이 곧 만료됩니다',
  'idle.content': '지금 세션을 재개하거나 로그아웃하세요',
  resume: '재개',
  name: '이름',
  'success.reloading': '성공, 페이지를 다시 불러오는 중',
  'fail.retry': '실패, 다시 시도해 주세요',
  tags: '태그',
  after: '이후',
  flow: '플로우',
  text: '텍스트',
  image: '이미지',
  video: '동영상',
  file: '파일',
  custom: '사용자 지정',
  input: '입력',
  quickReplies: '빠른 답장',
  ctaUrl: 'CTA URL',
  button: '버튼',
  question: '질문',
  fieldRequired: '이 필드는 필수입니다',
  entity: '엔터티',
  active: '활성',
  inactive: '비활성',
  deleted: '삭제됨',
  next: '다음',
  category: '카테고리',
  portalUser: '포털 사용자',
  role: '역할',
  admin: '관리자',
  user: '사용자',
  username: '사용자 이름',
  email: '이메일',
  firstName: '이름',
  lastName: '성',
  fullName: '전체 이름',
  resetPassword: '비밀번호 재설정',
  'resetPassword.emailSent': '비밀번호 재설정 이메일이 사용자에게 전송되었습니다',
  'resetPassword.confirm.title': '이 사용자의 비밀번호를 재설정하시겠습니까?',
  'resetPassword.confirm.content': '비밀번호 재설정 이메일이 {username} ({email})로 전송됩니다',
  'resetPassword.emailFailed': '재설정 이메일 전송에 실패했습니다. 다시 시도해 주세요',
  'resetPassword.tokenExpired': '비밀번호 재설정 토큰이 만료되었습니다',
  oldPassword: '현재 비밀번호',
  newPassword: '새 비밀번호',
  'password.characterNotMet':
    '비밀번호는 최소 하나의 문자, 하나의 숫자, 하나의 특수문자를 포함해야 합니다',
  confirmPassword: '비밀번호 확인',
  'confirmPassword.mismatch': '입력한 두 비밀번호가 일치하지 않습니다!',
  unlock: '잠금 해제',
  'portalUser.unlock.title': '이 사용자의 잠금을 해제합니다',
  'portalUser.unlock.content':
    '{username} ({email}) - 해당하는 경우 비밀번호 재설정 이메일이 사용자에게 전송됩니다',
  'portalUser.userPasswordModal.title': '사용자 비밀번호 창',
  logout: '로그아웃',
  dormant: '휴면',
  'portalUser.dormant.title': '이 사용자를 휴면 상태로 전환하시겠습니까?',
  'portalUser.dormant.content':
    '{username} ({email}) - 휴면 처리 후에는 이 사용자가 더 이상 이 포털에 접근할 수 없습니다',
  reactivate: '재활성화',
  'portalUser.reactivate.title': '이 사용자를 재활성화하시겠습니까?',
  'portalUser.reactivate.content':
    '{username} ({email}) - 재활성화 후 이 사용자는 즉시 이 포털에 다시 접근할 수 있습니다',
  'portalUser.delete.title': '이 사용자를 삭제하시겠습니까?',
  'portalUser.delete.content':
    '{username} ({email}) - 삭제 후에는 이 사용자가 더 이상 이 포털에 접근할 수 없습니다. 개인 데이터는 삭제되며, 대신 사용자를 휴면 상태로 전환할 수도 있습니다.',
  'portalUser.delete.undo': '{username} ({email}) 삭제됨',
  'portalUser.emailChange.title': '사용자 이메일을 변경하시겠습니까?',
  'portalUser.emailChange.content':
    '이메일이 {newEmail}로 업데이트되며 해당 주소로 비밀번호 재설정 이메일이 전송됩니다. 사용자는 로그아웃되며 다시 로그인하려면 새 비밀번호를 설정해야 합니다.',
  'portalUser.emailChange.noEmail.content':
    '이메일이 {newEmail}로 업데이트됩니다. 이 조직에는 이메일 서비스가 설정되어 있지 않으므로 새 비밀번호가 생성되어 사용자에게 전달할 수 있도록 화면에 표시됩니다.',
  platform: '플랫폼',
  notes: '메모',
  'pages.review.title': '검토',
  'pages.review.description':
    '질문 목록을 기반으로 하나 이상의 문서에 대한 구조화된 검토를 생성합니다',
  'pages.login.rememberMe': '로그인 상태 유지',
  'pages.login.forgotPassword': '비밀번호를 잊으셨나요?',
  'pages.welcome.alertMessage': '더 빠르고 강력한 대형 컴포넌트가 출시되었습니다.',
  'pages.admin.subPage.title': '이 페이지는 관리자만 볼 수 있습니다',
  'pages.file.placeholder.type': '유형',
  'pages.file.placeholder.people': '작성자',
  'pages.file.placeholder.search': '파일 또는 폴더 검색',
  'pages.file.placeholder.editfile': '파일 이름 수정',
  'pages.file.pdf': 'PDF',
  'pages.file.document': '문서',
  'pages.file.msg': 'MSG',
  'pages.file.eml': 'EML',
  'pages.file.txt': '텍스트',
  'pages.file.md': 'Markdown',
  'pages.file.excel': 'Excel',
  'pages.file.powerpoint': 'PowerPoint',
  'pages.file.uploading': '업로드 중',
  'pages.file.clickDragFile': '클릭하거나 파일을 이곳으로 끌어와 업로드하세요',
  'pages.file.createfolder': '폴더 생성',
  'pages.file.uploadFiles': '파일 업로드',
  'pages.file.upload.time': '업로드 시간:',
  'pages.file.created.time': '생성 시간:',
  'pages.file.favorites': '내 즐겨찾기',
  'pages.file.history': '수정 기록',
  'pages.file.success': '생성 성공',
  'pages.file.filePreview': '파일 미리보기',
  'pages.file.prompt.uploadFiled': '업로드 실패',
  'pages.file.prompt.network': '네트워크 오류',
  'pages.file.prompt.fetchFiles': '파일 목록 정보를 가져오지 못했습니다',
  'pages.file.prompt.createGroup': '그룹 생성에 실패했습니다',
  'pages.file.prompt.createFolderSucc': '폴더가 생성되었습니다',
  'pages.file.prompt.createFolderFail': '폴더 생성에 실패했습니다',
  'pages.file.prompt.updateSucc': '업데이트 성공',
  'pages.file.prompt.updateFail': '업데이트 실패',
  'pages.file.prompt.addFavoriteFail': '추가 실패',
  'pages.file.prompt.noPermission': '이 세션을 수정할 권한이 없습니다',
  'pages.file.prompt.duplicateName': '세션 이름이 중복됩니다',
  'pages.file.prompt.notFound': '세션을 찾을 수 없습니다',
  'pages.file.prompt.deleteGroupSuc': '삭제 성공',
  'pages.file.prompt.uploadFiles': '개 파일 업로드 준비됨',
  'pages.file.prompt.downloadSucc': '다운로드 성공',
  'pages.file.prompt.downloadFail': '다운로드 실패',
  'pages.file.prompt.authFail': '인증 토큰이 없습니다.',
  'pages.file.prompt.moveSucc': '파일이 이동되었습니다',
  'pages.chat.newWithUploadedDocument': '문서로 새 채팅 시작',
  'pages.chat.editSessionName': '세션 이름 수정',
  'pages.chat.placeholder.inputSessionName': '새 세션 이름을 입력하세요',
  'pages.chat.placeholder': '질문하고 싶은 내용을 입력하세요...',
  'pages.chat.word': '/10000자',
  'pages.chat.rateMessage.successfulLike': '메시지에 좋아요를 표시했습니다',
  'pages.chat.rateMessage.successfulDislike': '메시지에 싫어요를 표시했습니다',
  'pages.chat.actions.like': '좋은 응답',
  'pages.chat.actions.dislike': '나쁜 응답',
  'pages.chat.rateMessage.error': '메시지 평가에 실패했습니다',
  'pages.chat.selectContext.setFilePriority.success': '파일 우선순위가 업데이트되었습니다',
  'pages.chat.selectContext.setFilePriority.error': '파일 우선순위 업데이트 중 오류가 발생했습니다',
  'pages.chat.selectContext.toolTipDefault':
    '기본적으로 봇은 귀하가 접근 권한을 가진 모든 파일에 접근할 수 있습니다.',
  'pages.chat.rerank':
    '결과를 반환하기 전에 검색 결과를 다시 정렬합니다. 결과 품질이 향상될 수 있지만 검색 속도가 크게 느려질 수 있습니다.',
  'pages.chat.selectContext.tootlTipRestrict':
    '이 메뉴를 사용하여 모델이 사용할 수 있는 파일을 제한할 수 있습니다.',
  'pages.chat.hybridSearchAlphaTooltip':
    '검색 비율은 시맨틱 검색과 키워드 검색 간의 균형을 조절합니다. 값이 낮으면 키워드 검색을, 값이 높으면 시맨틱 검색을 우선합니다.',
  'pages.chat.favoriteFileWeight': '이 가중치는 즐겨찾기한 파일의 검색 순위를 인위적으로 높입니다.',
  'pages.dashboard.realTimeUsersTitleTooltip':
    '현재 봇과 상호작용 중이거나 지난 5분 이내에 봇과 상호작용한 사용자 수입니다.',
  'pages.dashboard.activeUsersTitleTooltip': '선택한 기간 동안 봇과 상호작용한 사용자 수입니다.',
  'pages.dashboard.newUsersTitleTooltip':
    '선택한 기간 동안 처음으로 봇과 상호작용한 사용자 수입니다.',
  'pages.dashboard.promptTokensTitleTooltip': '선택한 기간 동안 처리된 입력 토큰 수입니다.',
  'pages.dashboard.completionTokensTitleTooltip': '선택한 기간 동안 생성된 출력 토큰 수입니다.',
  'pages.dashboard.userMessagesTitleTooltip': '선택한 기간 동안 사용자가 보낸 메시지 수입니다.',
  'pages.dashboard.storyboardsTitleTooltip':
    '선택한 기간 동안 사전 제작된 챗봇 스토리보드가 처리한 사용자 메시지 수입니다.',
  'pages.dashboard.botMessagesTitleTooltip':
    '선택한 기간 동안 봇이 사용자에게 보낸 메시지 수입니다.',
  'pages.dashboard.broadcastsTitleTooltip':
    '선택한 기간 동안 브로드캐스트 기능을 통해 봇이 사용자에게 보낸 메시지 수입니다.',
  'pages.dashboard.repliesTitleTooltip':
    '선택한 기간 동안 사용자 메시지에 대한 응답으로 보낸 메시지 수입니다.',
  'pages.dashboard.messageExchangesTitleTooltip':
    '선택한 기간 동안 사용자와 봇이 주고받은 메시지 수입니다.',
  'pages.dashboard.broadcastTitleTooltip': '선택한 기간 동안 봇이 시작한 브로드캐스트 수입니다.',
  'pages.dashboard.outReachTitleTooltip':
    '선택한 기간 동안 모든 브로드캐스트 수신자 수의 합계입니다.',
  'pages.chat.stopGenerating': '생성이 중지되었습니다.',
  'pages.chat.stopGenerating.error': '생성 중지에 실패했습니다.',
  'pages.app.timeline': '타임라인',
  'pages.app.guided_summary': '가이드 요약',
  'pages.app.standard_info': '간단 정보',
  'pages.login.microsoftSSO': 'Microsoft로 로그인',
  'pages.login.loading': '로딩 중...',
  'pages.login.redirectingToMS': 'Microsoft SSO로 리디렉션 중...',
  'pages.loggedOut.title': '로그아웃됨',
  'pages.loggedOut.heading': '로그아웃되었습니다',
  'pages.loggedOut.description': '이 창을 닫거나 로그인 페이지로 돌아가 다시 로그인할 수 있습니다.',
  'pages.loggedOut.return': '로그인으로 돌아가기',
};
